import { render, staticRenderFns } from "./SelectUsersComponent.vue?vue&type=template&id=6452dcd9&scoped=true"
import script from "./SelectUsersComponent.vue?vue&type=script&lang=js"
export * from "./SelectUsersComponent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SelectUsersComponent.vue?vue&type=style&index=1&id=6452dcd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6452dcd9",
  null
  
)

export default component.exports